import { render, staticRenderFns } from "./CardProject.vue?vue&type=template&id=64c7de57&scoped=true&"
import script from "./CardProject.vue?vue&type=script&lang=ts&"
export * from "./CardProject.vue?vue&type=script&lang=ts&"
import style0 from "./CardProject.vue?vue&type=style&index=0&id=64c7de57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c7de57",
  null
  
)

export default component.exports